import { Grid, Header, Image, Item, Segment } from 'semantic-ui-react';
import WikiNav from '../WikiNav';
import { WikiSearchProvider } from '../WikiSearchContext';
import ResourceContent from './ResourceContent';

const sessionImageStyle = {
  filter: 'brightness(100%)',
};

const sessionImageTextStyle = {
  position: 'absolute',
  bottom: '5%',
  left: '1%',
  width: '100%',
  height: 'auto',
  color: 'white',
};

const Resources = () => {
  return (
    <WikiSearchProvider>
      <Grid id="detailed-segment">
        <Grid.Column width={16}>
          <Segment.Group>
            <Segment basic attached="top" style={{ padding: '0' }} id="segment">
              <Image
                src={`/assets/categoryImages/PinkHeader.svg`}
                id="header-image"
                fluid
                style={sessionImageStyle}
              />
              <Segment basic style={sessionImageTextStyle}>
                <Item.Group>
                  <Item>
                    <Item.Content>
                      <Header size="huge" id="wiki-header">
                        Resources
                      </Header>
                    </Item.Content>
                  </Item>
                </Item.Group>
              </Segment>
            </Segment>

            <Segment id="segment">
              <WikiNav />
              <Grid verticalAlign="middle">
                <Grid.Column width={16} id="dg">
                  <Header as="h3" id="pink">
                    Resources
                  </Header>
                  <ResourceContent />
                </Grid.Column>
              </Grid>
            </Segment>
          </Segment.Group>
        </Grid.Column>
      </Grid>
    </WikiSearchProvider>
  );
};

export default Resources;
